<template>
  <div id="zalacz">
    <span data-toggle="collapse" data-target="#fileuploadform" class="fw-bold add_images fs-5 d-inline-block"
            onclick="$('#fileuploadform').toggle()">
          {{ $t('wz_case_form.service_order_data.add_button') }}
      <svg width="26" height="25" viewBox="0 0 26 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M0.908203 6.94444C0.908203 3.10913 4.01734 0 7.85265 0H18.9638C22.7991 0 25.9082 3.10913 25.9082 6.94444V18.0556C25.9082 21.8909 22.7991 25 18.9638 25H7.85265C4.01734 25 0.908203 21.8909 0.908203 18.0556V6.94444ZM11.2019 6.61763C11.2019 5.39935 12.1895 4.41175 13.4078 4.41175C14.6261 4.41175 15.6137 5.39935 15.6137 6.61763V10.2941H19.2902C20.5084 10.2941 21.496 11.2817 21.496 12.5C21.496 13.7183 20.5084 14.7059 19.2902 14.7059H15.6137V18.3823C15.6137 19.6006 14.6261 20.5882 13.4078 20.5882C12.1895 20.5882 11.2019 19.6006 11.2019 18.3823V14.7059H7.52545C6.30718 14.7059 5.31957 13.7183 5.31957 12.5C5.31957 11.2817 6.30718 10.2941 7.52545 10.2941H11.2019V6.61763Z" fill="#23AE84"/>
      </svg>
    </span>
  </div>
  <div id="fileuploadform" class="collapse">
    <div class="main-pattern "  onclick="$('.instruction').toggle(); $('.down').toggle(); $('.up').toggle();">
      <span class="additional-info">
        <svg fill="#23AE84" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
             xmlns:xlink="http://www.w3.org/1999/xlink" width="20px" height="20px" viewBox="0 0 416.979 416.979"
             xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <path d="M356.004,61.156c-81.37-81.47-213.377-81.551-294.848-0.182c-81.47,81.371-81.552,213.379-0.181,294.85 c81.369,81.47,213.378,81.551,294.849,0.181C437.293,274.636,437.375,142.626,356.004,61.156z M237.6,340.786 c0,3.217-2.607,5.822-5.822,5.822h-46.576c-3.215,0-5.822-2.605-5.822-5.822V167.885c0-3.217,2.607-5.822,5.822-5.822h46.576 c3.215,0,5.822,2.604,5.822,5.822V340.786z M208.49,137.901c-18.618,0-33.766-15.146-33.766-33.765 c0-18.617,15.147-33.766,33.766-33.766c18.619,0,33.766,15.148,33.766,33.766C242.256,122.755,227.107,137.901,208.49,137.901z"></path> </g> </g></svg>
      </span>
      <span class="show-desktop">{{ $t('wz_case_form.upload_file.instruction_desktop') }}</span>
      <span class="show-mobile">{{ $t('wz_case_form.upload_file.instruction_mobile') }}</span>
      <span class="down">
        <svg width="35px" height="35px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" transform="rotate(180)"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M12 7C12.2652 7 12.5196 7.10536 12.7071 7.29289L19.7071 14.2929C20.0976 14.6834 20.0976 15.3166 19.7071 15.7071C19.3166 16.0976 18.6834 16.0976 18.2929 15.7071L12 9.41421L5.70711 15.7071C5.31658 16.0976 4.68342 16.0976 4.29289 15.7071C3.90237 15.3166 3.90237 14.6834 4.29289 14.2929L11.2929 7.29289C11.4804 7.10536 11.7348 7 12 7Z" fill="#23AE84"></path> </g></svg>
      </span>
      <span class="up">
        <svg width="35px" height="35px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M12 7C12.2652 7 12.5196 7.10536 12.7071 7.29289L19.7071 14.2929C20.0976 14.6834 20.0976 15.3166 19.7071 15.7071C19.3166 16.0976 18.6834 16.0976 18.2929 15.7071L12 9.41421L5.70711 15.7071C5.31658 16.0976 4.68342 16.0976 4.29289 15.7071C3.90237 15.3166 3.90237 14.6834 4.29289 14.2929L11.2929 7.29289C11.4804 7.10536 11.7348 7 12 7Z" fill="#23AE84"></path> </g></svg>
      </span>
    </div>
    <div class="instruction">
      <div class="card w-100 h-100 mb-0 pb-0 pl-15">
        <div class="card-body">
          <table class="ml-5 mb-3 d-grid align-items-start">
            <tr class="show-mobile">
              <td class="w-auto fs-16 pl-10 align-items-start">
                {{ $t('wz_case_form.wz2_form.upload_file.instruction_mobile_description') }}
              </td>
            </tr>
            <tr v-if="!mp4" class="files-info">
              <td class="w30px align-content-start pt-2">
                <svg fill="#23AE84" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="28px" height="28px" viewBox="0 0 400 400" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <g> <path d="M199.996,0C89.713,0,0,89.72,0,200s89.713,200,199.996,200S400,310.28,400,200S310.279,0,199.996,0z M199.996,373.77 C104.18,373.77,26.23,295.816,26.23,200c0-95.817,77.949-173.769,173.766-173.769c95.817,0,173.771,77.953,173.771,173.769 C373.768,295.816,295.812,373.77,199.996,373.77z"></path> <path d="M272.406,134.526L169.275,237.652l-41.689-41.68c-5.123-5.117-13.422-5.12-18.545,0.003 c-5.125,5.125-5.125,13.425,0,18.548l50.963,50.955c2.561,2.558,5.916,3.838,9.271,3.838s6.719-1.28,9.279-3.842 c0.008-0.011,0.014-0.022,0.027-0.035L290.95,153.071c5.125-5.12,5.125-13.426,0-18.546 C285.828,129.402,277.523,129.402,272.406,134.526z"></path> </g> </g> </g></svg>
              </td>
              <td class="w-auto fs-16 pl-10 align-items-start">
                {{ $t('wz_case_form.upload_file.instruction_list_1_1') }}
                <b>{{ $t('wz_case_form.upload_file.instruction_list_1_2') }}</b>
              </td>
            </tr>
            <tr v-if="!mp4" class="empty-tr">
              <td colspan="2" class="h10px"></td>
            </tr>
            <tr v-if="!mp4" class="files-info">
              <td class="w30px align-content-start pt-2">
                <svg fill="#23AE84" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="28px" height="28px" viewBox="0 0 400 400" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <g> <path d="M199.996,0C89.713,0,0,89.72,0,200s89.713,200,199.996,200S400,310.28,400,200S310.279,0,199.996,0z M199.996,373.77 C104.18,373.77,26.23,295.816,26.23,200c0-95.817,77.949-173.769,173.766-173.769c95.817,0,173.771,77.953,173.771,173.769 C373.768,295.816,295.812,373.77,199.996,373.77z"></path> <path d="M272.406,134.526L169.275,237.652l-41.689-41.68c-5.123-5.117-13.422-5.12-18.545,0.003 c-5.125,5.125-5.125,13.425,0,18.548l50.963,50.955c2.561,2.558,5.916,3.838,9.271,3.838s6.719-1.28,9.279-3.842 c0.008-0.011,0.014-0.022,0.027-0.035L290.95,153.071c5.125-5.12,5.125-13.426,0-18.546 C285.828,129.402,277.523,129.402,272.406,134.526z"></path> </g> </g> </g></svg>
              </td>
              <td class="w-auto fs-16 pl-10 align-items-start">
                {{ $t('wz_case_form.upload_file.instruction_list_4_1') }}
                <b>{{ $t('wz_case_form.upload_file.instruction_list_4_2') }}</b>
              </td>
            </tr>
            <tr class="empty-tr">
              <td colspan="2" class="h10px"></td>
            </tr>
            <tr class="files-info">
              <td class="w30px align-content-start pt-2">
                <svg fill="#23AE84" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="28px" height="28px" viewBox="0 0 400 400" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <g> <path d="M199.996,0C89.713,0,0,89.72,0,200s89.713,200,199.996,200S400,310.28,400,200S310.279,0,199.996,0z M199.996,373.77 C104.18,373.77,26.23,295.816,26.23,200c0-95.817,77.949-173.769,173.766-173.769c95.817,0,173.771,77.953,173.771,173.769 C373.768,295.816,295.812,373.77,199.996,373.77z"></path> <path d="M272.406,134.526L169.275,237.652l-41.689-41.68c-5.123-5.117-13.422-5.12-18.545,0.003 c-5.125,5.125-5.125,13.425,0,18.548l50.963,50.955c2.561,2.558,5.916,3.838,9.271,3.838s6.719-1.28,9.279-3.842 c0.008-0.011,0.014-0.022,0.027-0.035L290.95,153.071c5.125-5.12,5.125-13.426,0-18.546 C285.828,129.402,277.523,129.402,272.406,134.526z"></path> </g> </g> </g></svg>
              </td>
              <td class="w-auto fs-16 pl-10 align-items-start">
                {{ $t('wz_case_form.upload_file.instruction_list_2_1') }}
                <b v-if="mp4">{{ $t('wz_case_form.upload_file.instruction_list_2_3') }}</b>
                <b v-else>{{ $t('wz_case_form.upload_file.instruction_list_2_2') }}</b>
              </td>
            </tr>
            <tr class="empty-tr">
              <td colspan="2" class="h10px"></td>
            </tr>
            <tr class="show-desktop">
              <td class="w30px align-items-start pt-2">
                <svg fill="#23AE84" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="28px" height="28px" viewBox="0 0 400 400" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <g> <path d="M199.996,0C89.713,0,0,89.72,0,200s89.713,200,199.996,200S400,310.28,400,200S310.279,0,199.996,0z M199.996,373.77 C104.18,373.77,26.23,295.816,26.23,200c0-95.817,77.949-173.769,173.766-173.769c95.817,0,173.771,77.953,173.771,173.769 C373.768,295.816,295.812,373.77,199.996,373.77z"></path> <path d="M272.406,134.526L169.275,237.652l-41.689-41.68c-5.123-5.117-13.422-5.12-18.545,0.003 c-5.125,5.125-5.125,13.425,0,18.548l50.963,50.955c2.561,2.558,5.916,3.838,9.271,3.838s6.719-1.28,9.279-3.842 c0.008-0.011,0.014-0.022,0.027-0.035L290.95,153.071c5.125-5.12,5.125-13.426,0-18.546 C285.828,129.402,277.523,129.402,272.406,134.526z"></path> </g> </g> </g></svg>
              </td>
              <td class="w-auto fs-16 pl-10 align-items-start">
                {{ $t('wz_case_form.upload_file.instruction_list_3_1') }}
                <b>{{ $t('wz_case_form.upload_file.instruction_list_3_2') }}</b>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <div class="main upload-field">
      <div
          class="dropzone-container"
          @dragover="dragover"
          @dragleave="dragleave"
          @drop="drop"
      >
        <input v-if="mp4"
            type="file"
            multiple
            name="file"
            id="fileInput"
            class="hidden-input"
            @change="onChange"
            ref="file"
            accept=".pdf,.jpg,.jpeg,.png, .mp4"
        />
        <input v-else
               type="file"
               multiple
               name="file"
               id="fileInput"
               class="hidden-input"
               @change="onChange"
               ref="file"
               accept=".pdf,.jpg,.jpeg,.png"
               size="999"
        />

        <label for="fileInput" class="file-label">
          <div v-if="isDragging">Release to drop files here.</div>
          <div v-else class="mt-2">
            <div class="d-inline-block">
              <div class="copy-file">
                <svg width="41" height="47" viewBox="0 0 41 47" fill="#23AE84" xmlns="http://www.w3.org/2000/svg">
                  <path d="M40.0772 11.3446C40.0761 11.0965 39.9945 10.8554 39.8446 10.6575C39.6948 10.4595 39.4847 10.3155 39.2459 10.2468L29.1401 0.420736C29.0328 0.289807 28.8978 0.184193 28.7448 0.111455C28.5918 0.0387176 28.4246 0.000657326 28.2552 0L10.6333 0C10.0888 0 9.5665 0.215995 9.18143 0.600469C8.79635 0.984943 8.58002 1.5064 8.58002 2.05013V7.80656H2.99083C2.44625 7.80656 1.92398 8.02256 1.53891 8.40703C1.15383 8.7915 0.9375 9.31296 0.9375 9.85669L0.9375 44.9499C0.9375 45.4936 1.15383 46.0151 1.53891 46.3995C1.92398 46.784 2.44625 47 2.99083 47H30.3966C30.9392 46.997 31.4585 46.7796 31.8411 46.3955C32.2237 46.0113 32.4385 45.4916 32.4385 44.9499V39.2126H38.0277C38.5702 39.2095 39.0896 38.9922 39.4722 38.6081C39.8548 38.2239 40.0695 37.7042 40.0695 37.1624C40.0695 28.5616 40.0695 19.962 40.0695 11.3637L40.0772 11.3446ZM10.8632 7.80656V2.29492H27.1059V11.5664C27.1059 11.8707 27.227 12.1626 27.4426 12.3778C27.6581 12.593 27.9504 12.7139 28.2552 12.7139H37.7825C37.7825 20.7767 37.7825 28.8395 37.7825 36.9023H32.4193V19.1473C32.4182 18.8992 32.3367 18.6581 32.1868 18.4602C32.0369 18.2623 31.8268 18.1182 31.588 18.0496L21.5053 8.2273C21.3996 8.09542 21.2655 7.98908 21.113 7.91623C20.9604 7.84337 20.7933 7.80588 20.6242 7.80656H10.8632ZM21.7658 11.815L28.6268 18.2332H21.7658V11.815ZM3.236 44.7089V10.0862H19.4788V19.373C19.4788 19.6773 19.5998 19.9692 19.8154 20.1843C20.0309 20.3995 20.3232 20.5204 20.628 20.5204H30.1515C30.1515 28.5884 30.1515 36.6512 30.1515 44.7089H3.236ZM7.57634 26.6517C7.65177 26.5639 7.74515 26.4932 7.8502 26.4443C7.95526 26.3955 8.06957 26.3697 8.18544 26.3687H21.6508C21.767 26.3692 21.8817 26.3944 21.9874 26.4425C22.093 26.4906 22.1872 26.5606 22.2638 26.6479C22.4216 26.8276 22.5075 27.0591 22.5051 27.2981C22.5054 27.5374 22.4182 27.7686 22.2599 27.9483C22.1839 28.0354 22.0904 28.1056 21.9855 28.1543C21.8805 28.2031 21.7665 28.2293 21.6508 28.2314H8.18544C8.06934 28.2306 7.95471 28.2053 7.84908 28.1572C7.74344 28.1091 7.64919 28.0392 7.57251 27.9522C7.4154 27.7718 7.32887 27.5409 7.32887 27.3019C7.32887 27.0629 7.4154 26.832 7.57251 26.6517H7.57634ZM7.57634 37.7209C7.65102 37.6331 7.74371 37.5625 7.84814 37.5136C7.95257 37.4648 8.0663 37.4389 8.18161 37.4378H25.4051C25.5209 37.4389 25.6352 37.4647 25.7403 37.5135C25.8454 37.5623 25.9387 37.633 26.0142 37.7209C26.1724 37.9006 26.2596 38.1318 26.2593 38.3711C26.2617 38.6101 26.1758 38.8416 26.018 39.0213C25.9415 39.1086 25.8472 39.1786 25.7416 39.2267C25.6359 39.2748 25.5212 39.3 25.4051 39.3005H8.19311C8.07757 39.2997 7.96352 39.2744 7.85852 39.2263C7.75351 39.1781 7.65994 39.1083 7.584 39.0213C7.42459 38.8421 7.33655 38.6108 7.33655 38.3711C7.33655 38.1314 7.42459 37.9001 7.584 37.7209H7.57634ZM25.4051 31.9032C25.5209 31.9043 25.6352 31.9301 25.7403 31.9789C25.8454 32.0277 25.9387 32.0984 26.0142 32.1863C26.1713 32.3666 26.2578 32.5975 26.2578 32.8365C26.2578 33.0755 26.1713 33.3064 26.0142 33.4867C25.9374 33.5735 25.8431 33.6429 25.7374 33.6904C25.6317 33.7379 25.5171 33.7623 25.4012 33.7621H8.19311C8.07782 33.762 7.96387 33.7374 7.85885 33.6899C7.75383 33.6424 7.66014 33.5732 7.584 33.4867C7.42423 33.3064 7.3369 33.0734 7.33883 32.8327C7.33802 32.5937 7.42685 32.3631 7.58783 32.1863C7.66251 32.0985 7.7552 32.0279 7.85964 31.979C7.96407 31.9302 8.07779 31.9044 8.19311 31.9032H25.4051ZM7.57634 21.1133C7.65259 21.0267 7.74623 20.9571 7.85116 20.909C7.95609 20.8609 8.06999 20.8354 8.18544 20.8341H16.1498C16.2656 20.8339 16.3803 20.8583 16.4859 20.9058C16.5916 20.9533 16.686 21.0227 16.7627 21.1095C16.9193 21.2907 17.0055 21.5222 17.0055 21.7616C17.0055 22.001 16.9193 22.2325 16.7627 22.4137C16.6864 22.5003 16.5928 22.5699 16.4879 22.618C16.3829 22.6661 16.269 22.6916 16.1536 22.693H8.18544C8.06959 22.6929 7.95506 22.6683 7.84941 22.6209C7.74376 22.5734 7.64939 22.5041 7.57251 22.4176C7.41586 22.2363 7.32968 22.0048 7.32968 21.7654C7.32968 21.526 7.41586 21.2946 7.57251 21.1133H7.57634ZM7.57634 15.5787C7.65313 15.4908 7.74794 15.4204 7.85434 15.3722C7.96075 15.324 8.07627 15.2992 8.19311 15.2995H12.5718C12.687 15.2996 12.801 15.3242 12.906 15.3717C13.011 15.4192 13.1047 15.4884 13.1809 15.5749C13.3375 15.7561 13.4237 15.9876 13.4237 16.227C13.4237 16.4664 13.3375 16.6979 13.1809 16.8792C13.1053 16.9656 13.0124 17.0352 12.9081 17.0833C12.8038 17.1314 12.6905 17.157 12.5756 17.1584H8.19311C8.07798 17.1573 7.96434 17.1323 7.85945 17.0848C7.75457 17.0374 7.66075 16.9687 7.584 16.883C7.42485 16.7023 7.33762 16.4696 7.33883 16.2289C7.33854 15.9889 7.42724 15.7573 7.58783 15.5787H7.57634ZM29.4006 4.00846L36.2616 10.4266H29.4006V4.00846Z" fill="#23AE84"/>
                </svg>
              </div>
              <div>
                <div class="choose-button border-0">
                <span class="button-icon">
                  <svg width="20" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M17.1354 5.36816H13.8032V7.33851H17.1354C18.1268 7.33851 18.8956 7.84259 18.8956 8.27672V17.0142C18.8956 17.448 18.1268 17.9528 17.1354 17.9528H4.53905C3.54804 17.9528 2.77916 17.448 2.77916 17.0142V8.27771C2.77916 7.84358 3.54804 7.33917 4.53905 7.33917H7.87097V5.36882H4.53905C2.44333 5.36882 0.801758 6.64659 0.801758 8.27771V17.0146C0.801758 18.646 2.44333 19.9231 4.53905 19.9231H17.1361C19.2311 19.9231 20.8734 18.6453 20.8734 17.0146V8.27771C20.8731 6.64593 19.2315 5.36816 17.1354 5.36816Z" fill="white"/>
                    <path d="M13.8286 9.48623C13.5755 9.48623 13.3227 9.58278 13.1296 9.77522L11.8917 11.0083V6.73037V4.76003V0.985173C11.8917 0.441358 11.4491 0 10.903 0C10.357 0 9.91434 0.441358 9.91434 0.985173V4.7597V6.73005V11.0747L8.60959 9.77489C8.41646 9.58245 8.16335 9.4859 7.91058 9.4859C7.6578 9.4859 7.40469 9.58245 7.21156 9.77489C6.82531 10.1591 6.82531 10.783 7.21156 11.1676L10.1635 14.109C10.3566 14.3014 10.6097 14.397 10.8622 14.397C10.8648 14.397 10.8675 14.397 10.8698 14.397C10.8721 14.397 10.8747 14.397 10.877 14.397C11.1301 14.397 11.3826 14.3014 11.5757 14.109L14.5276 11.1676C14.9139 10.783 14.9139 10.1591 14.5276 9.77489C14.3345 9.58278 14.082 9.48623 13.8286 9.48623Z" fill="white"/>
                  </svg>
                </span>
                  Wybierz pliki
                </div>
              </div>
              <p class="show-desktop under-button-label">lub upuść pliki tutaj</p>
            </div>
          </div>
        </label>
        <!-- Note: Only add the code block below -->
        <div class="preview-container mt-4 mb-3" v-if="files.length">

            <div v-for="file in files" :key="file.name" class="preview-file">
              <div class="w-75">
                {{ file.name }}
              </div>
              <div class="w-15">
                {{ Math.round(file.size / 1000, 1) + "Kb" }}
              </div>
              <div class="w-10 remove-file">
                <span
                    class="ml-2 remove-file-button"
                    type="button"
                    @click="remove(files.indexOf(file))"
                    title="Remove file"
                >
                  <svg width="20px" height="20px" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" fill="#ff0000" stroke="#ff0000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path fill="#ff0000" d="M195.2 195.2a64 64 0 0 1 90.496 0L512 421.504 738.304 195.2a64 64 0 0 1 90.496 90.496L602.496 512 828.8 738.304a64 64 0 0 1-90.496 90.496L512 602.496 285.696 828.8a64 64 0 0 1-90.496-90.496L421.504 512 195.2 285.696a64 64 0 0 1 0-90.496z"></path></g></svg>
                </span>
              </div>
            </div>
        </div>
      </div>
    </div>
    <div class="show-mobile w-100">
      <div class="w-100 or">
        <hr class="hr-ccs-thin w-45">
        <span class=""> lub </span>
        <hr class="hr-ccs-thin w-45">
      </div>

      <div class="main-pattern ">
          <label for="fileInputCamera" class="launch-camera capture-button">
            <svg width="25px" height="25px" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M3 3H0V14H16V3H13L11 1H5L3 3ZM8 11C9.65685 11 11 9.65685 11 8C11 6.34315 9.65685 5 8 5C6.34315 5 5 6.34315 5 8C5 9.65685 6.34315 11 8 11Z" fill="#23AE84"></path> </g></svg>
            {{ $t('wz_case_form.upload_file.launch_camera') }}
          </label>
        <input v-if="mp4"
                 type="file"
                 multiple
                 name="file"
                 id="fileInputCamera"
                 accept="image/*, video/*" capture="environment"
                 ref="filePhone"
                 class="hidden-input"
                 @change="onChangeFromPhone"
          />
        <input v-else
               type="file"
               name="file"
               multiple
               id="fileInputCamera"
               accept="image/*" capture="environment"
               ref="filePhone"
               size="999"
               class="hidden-input"
               @change="onChangeFromPhone"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isDragging: false,
      files: [],
    };
  },
  props: {
    mp4: Boolean,
  },
  emits: ["getDroppedFiles"],
  methods: {
    onChange() {
      const self = this;
      let incomingFiles = Array.from(this.$refs.file.files);
      const fileExist = self.files.some((r) =>
          incomingFiles.some(
              (file) => file.name === r.name && file.size === r.size
          )
      );
      if (fileExist) {
        self.showMessage = true;
        alert("New upload contains files that already exist");
      } else {
        self.files.push(...incomingFiles);
      }
      this.$emit('getDroppedFiles', self.files);
    },
    onChangeFromPhone() {
      const self = this;
      let incomingFiles = Array.from(this.$refs.filePhone.files);
      const fileExist = self.files.some((r) =>
          incomingFiles.some(
              (file) => file.name === r.name && file.size === r.size
          )
      );
      if (fileExist) {
        self.showMessage = true;
        alert("New upload contains files that already exist");
      } else {
        self.files.push(...incomingFiles);

      }
      this.$emit('getDroppedFiles', self.files);
    },
    dragover(e) {
      e.preventDefault();
      this.isDragging = true;
    },
    dragleave() {
      this.isDragging = false;
    },
    drop(e) {
      e.preventDefault();
      this.$refs.file.files = e.dataTransfer.files;
      this.onChange();
      this.isDragging = false;
    },
    remove(i) {
      this.files.splice(i, 1);
      this.$emit('getDroppedFiles', this.files);
    },
    generateURL(file) {
      let fileSrc = URL.createObjectURL(file);
      setTimeout(() => {
        URL.revokeObjectURL(fileSrc);
      }, 1000);
      return fileSrc;
    },
  },
};
</script>
<style>
.main-pattern {
  background-color: rgba(35,174,132, 0.2);
  color: #23AE84;
  padding: 9px;
  border-radius: 20px;
  border: none;
  z-index: 999;
  position: relative;
}
.show-desktop, .show-mobile {
  display: none;
}
.main-pattern span{
 font-weight: 600;
}
.w-45 {
  width: 45%;
}
.w-15 {
  width: 18%;
}
.w-10 {
  width: 7%;
}
.main-pattern .additional-info {
  margin-right: 10px;
  margin-left: 10px;
}
.launch-camera {
  width: 100%;
  margin: 0 auto;
  align-content: center;
  text-align: center;
  font-weight: bold;
  font-family: Mulish;
}
.launch-camera svg {
  margin-right: 10px;
}
.down {
  float: right;
  top: -5px;
  position: relative;
}
.up {
  display: none;
  float: right;
  top: -5px;
  position: relative;
}
.main {
  flex-grow: 1;
  align-items: center;
  align-content: center;
  min-height: 200px;
  justify-content: center;
  text-align: center;
  border-radius: 20px;
  border: #23AE84 3px dotted;
  width: 100%;
  margin-top: 10px;
}
.pl-15 {
  padding-left: 15px;
}
.pl-10 {
  padding-left: 10px;
}
.dropzone-container {
  height: auto;
}
.fs-16 {
  font-size: 16px;
}
.hidden-input {
  opacity: 0;
  overflow: hidden;
  position: absolute;
  width: 1px;
  height: 1px;
}

.file-label {
  font-size: 20px;
  display: block;
  cursor: pointer;
}

.preview-container {
  display: inline-block;
  justify-content: center;
  text-align: left;
  width: 100%;
}
.preview-file {
  width: 100%;
  display: flex;
  padding: 5px 10px;
  color: #23AE84;
}
.preview-file div button {
  font-family: Mulish;
  justify-content: center;
  align-content: center;
  text-align: center;
}

.preview-card {
  display: flex;
  max-width: 30%;
  border: 1px solid #23AE84;
  padding: 5px;
  margin: 0 2px 5px 2px;
  color: #23AE84;
  border-radius: 10px;
  font-family: Mulish;
  justify-content: center;
  align-content: center;
  text-align: center;
}
.add_images {
  color: #23AE84;
}
.add_images svg {
  vertical-align: top;
}
.copy-file {
  width: 100%;
  height: auto;
}
.choose-button {
  width: 160px;
  height: 40px;
  background-color: #23AE84;
  border-radius: 20px;
  color: #ffffff;
  font-size: 14px;
  font-family: Mulish;
  margin-top: 15px;
  align-content: center;
  font-weight: 700;
}
.button-icon {
  display: inline-block;
  position: relative;
  top: -2px;
}
.under-button-label {
  font-family: Mulish;
  font-size: 14px;
  font-weight: 700;
  line-height: 17.57px;
  color: #23AE84;
  margin-top: 15px;
  text-align: center;
}
.h10px {
  height: 10px;
}
.instruction {
  display: none;
  border: none;
  top: -40px;
  position: relative;
  margin-bottom: -40px;
}
.instruction table {
  width: 85%;
}
.instruction .card {
  border: none;
  box-shadow: 0 5px 5px #ccc;
  padding-top: 40px;
  border-radius: 20px;
}
#fileuploadform {
  margin-top: 25px;
  margin-bottom: 25px;
}
.upload-field {
  margin-top: 30px;
}
@media (max-width: 768px) {
  .show-desktop {
    display: none;
  }
  #zalacz {
    margin-top: 15px;
    margin-bottom: 15px;
  }
  .show-mobile {
    display: inline-block;
  }
  .instruction .show-mobile td {
    padding-left: 0;
    font-weight: 700;
    padding-bottom: 25px;
    padding-top: 10px;
  }
  .instruction .empty-tr {
    height: 25px;
  }
  .or {
    display: flex;
    margin: 20px 0;
  }
  .or span {
    width: 10%;
    text-align: center;
    align-content: center;
    font-size: 10px;
    color: #4E4E4E;
  }
  .main {
    min-height: 140px;
  }
  .files-info {
    display: flex;
  }
  .preview-file {
    color: #23AE84;
    font-size: 14px;
  }
}
@media (min-width: 768px) {
  .show-desktop {
    display: inline-block;
  }
  .show-mobile {
    display: none;
  }
  #zalacz {
    margin-top: 5px;
    margin-bottom: 5px;
  }
  .preview-file {
    color: #23AE84;
    font-size: 16px;
    margin-left: 15px;
  }
}
.remove-file {
  align-content: flex-start;
  text-align: center;
}
</style>